import { useAppContext } from "@/providers";
import { performLogout } from "@/lib/auth/session-store";
import { t } from "@/lib/i18n/messages";

export function AccountMenu() {
  const { locale, session, setSession } = useAppContext();

  if (!session.isAuthenticated) return null;

  const onLogout = async () => {
    const nextState = await performLogout();
    setSession(nextState);
  };

  return (
    <button
      onClick={onLogout}
      className="text-sm rounded-lg border border-border px-4 py-2 text-foreground-secondary hover:text-foreground hover:bg-muted transition-colors duration-base"
    >
      {t(locale, "logout")}
    </button>
  );
}
